import { render, staticRenderFns } from "./LancarConceito.vue?vue&type=template&id=20cdf5f6&"
import script from "./LancarConceito.vue?vue&type=script&lang=js&"
export * from "./LancarConceito.vue?vue&type=script&lang=js&"
import style0 from "./LancarConceito.vue?vue&type=style&index=0&id=20cdf5f6&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports